// @ts-nocheck
import MyWorker from '../worker.js?worker'
import cookieToJSON from '../helpers/cookie-to-json'
const worker = new MyWorker()

export default defineNuxtPlugin(() => {
  const { $bus } = useNuxtApp()
  const authStore = useAuthStore()
  const baseURL = useRuntimeConfig().public.baseURL
  const headers = {
    'Content-Type': 'application/json'
  }
  const cookies = cookieToJSON(document.cookie)
  const route = useRoute()
  const fbp = cookies?._fbp
  let fbc = cookies?._fbc

  if (!fbc && route.query?.fbclid) {
    fbc = 'fb.1.' + Date.now() + '.' + route.query.fbclid
  }

  const getHeaders = () => {
    return authStore.getValidAccessToken().then(accessToken => {
      if (accessToken) {
        headers.Ggauthorization = `Bearer ${accessToken}`
      } else {
        delete headers.Ggauthorization
      }
      return headers
    })
  }

  worker.onmessage = e => {
    if (e.data.status === 401) {
      // Unauthorized. Try without auth header
      delete headers.Ggauthorization
      worker.postMessage({ data: e.data.data, url: e.data.url, headers })
    }
  }

  $bus.$on('add-to-cart', ({ eventId, sourceUrl, product, size }) => {
    getHeaders().then(headers => {
      worker.postMessage({
        url: baseURL + 'events/fb',
        data: {
          eventName: 'AddToCart',
          eventId,
          sourceUrl,
          contentIds: size.pId,
          value: product.price.replace(',', '.'),
          fbc,
          fbp
        },
        headers
      })
    })
  })

  $bus.$on('add-to-wishlist', async ({ eventId, sourceUrl, product }) => {
    const headers = await getHeaders()

    if (headers) {
      worker.postMessage({
        url: baseURL + 'events/fb',
        data: {
          eventName: 'AddToWishlist',
          eventId,
          sourceUrl,
          contentIds: product.cId,
          value: product.price.replace(',', '.'),
          fbc,
          fbp
        },
        headers
      })
    }
  })

  // Not working right now
  // $bus.$on('remove-from-wishlist', async ({ eventId, sourceUrl, product } : { eventId: Number, sourceUrl: string, product: any}) => {
  //   const headers = await getHeaders()

  //   if (headers) {
  //     worker.postMessage({
  //       url: baseURL + 'events/fb',
  //       data: {
  //         eventName: 'RemoveFromWishlist',
  //         eventId,
  //         sourceUrl,
  //         contentIds: product.cId,
  //         value: product.price.replace(',', '.'),
  //         fbc,
  //         fbp
  //       },
  //       headers
  //     })
  //   }
  // })

  $bus.$on('view-details', ({ eventId, product, sourceUrl }) => {
    getHeaders().then(headers => {
      worker.postMessage({
        url: baseURL + 'events/fb',
        data: {
          eventName: 'ViewContent',
          eventId,
          sourceUrl,
          contentIds: product ? product.cId : false,
          value:
            product && product.price ? product.price.replace(',', '.') : false,
          fbc,
          fbp
        },
        headers
      })
    })
  })

  $bus.$on(
    'add-impressions',
    ({ eventId, products, sourceUrl, category }) => {
      const cIds = products.map(product => {
        return `${product.cId}`
      })
      getHeaders().then(headers => {
        worker.postMessage({
          url: baseURL + 'events/fb',
          data: {
            eventName: 'ViewCategory',
            eventId,
            sourceUrl,
            contentIds: cIds,
            contentCategory: category ? category.slug : 'various',
            contentName: category ? category.title : 'various',
            fbc,
            fbp
          },
          headers
        })
      })
    }
  )

  $bus.$on(
    'checkout-progress',
    ({ eventId, sourceUrl, pIds, step, cartTotal }) => {
      getHeaders().then(headers => {
        if (step == 1) {
          worker.postMessage({
            url: baseURL + 'events/fb',
            data: {
              eventName: 'InitiateCheckout',
              eventId,
              sourceUrl,
              contentIds: pIds,
              value: cartTotal,
              fbc,
              fbp
            },
            headers
          })

          return true
        }

        worker.postMessage({
          url: baseURL + 'events/fb',
          data: {
            eventName: 'AddPaymentInfo',
            eventId,
            sourceUrl,
            contentIds: pIds,
            value: cartTotal,
            fbc,
            fbp
          },
          headers
        })

        return true
      })
    }
  )

  $bus.$on('complete-registration', ({ eventId, sourceUrl }) => {
    getHeaders().then(headers => {
      worker.postMessage({
        url: baseURL + 'events/fb',
        data: {
          eventName: 'CompleteRegistration',
          eventId,
          sourceUrl,
          fbc,
          fbp
        },
        headers
      })
    })
  })

  $bus.$on('event-contact', ({ eventId, sourceUrl }) => {
    getHeaders().then(headers => {
      worker.postMessage({
        url: baseURL + 'events/fb',
        data: {
          eventName: 'Contact',
          eventId,
          sourceUrl,
          fbc,
          fbp
        },
        headers
      })
    })
  })

  $bus.$on('purchase', ({ invoiceId, sourceUrl, total, pIds }) => {
    getHeaders().then(headers => {
      worker.postMessage({
        url: baseURL + 'events/fb',
        data: {
          eventName: 'Purchase',
          eventId: invoiceId,
          sourceUrl,
          contentIds: pIds,
          value: total,
          fbc,
          fbp
        },
        headers
      })
    })
  })
})
